import { View, Platform } from 'react-native';
import React, { useCallback, useEffect, useState } from 'react';
import {
  Banner,
  Footer,
  KeyboardScreenContainer,
  RadioGroup,
  Text,
} from '~/components';
import { useForm } from 'react-hook-form';
import type { MarisaAutoStepsProps } from '../..';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import useMarisaAutoForm from '~/stores/marisaAutoForm';
import { getUsageListUseCase } from '~/useCases/AssegurouUseCases/GetUsageListUseCase';

interface Question {
  question: string;
  description?: string;
  questionTitle?: string;
}

interface UsageQuizForm {
  usageVehicle: string;
}
const QUESTION: Question = {
  question: 'Como utiliza o carro?',
  description:
    'Saber para qual finalidade o carro é utilizado no dia a dia ajudará nosso corretor virtual a identificar os planos que melhor vão te atender.',
  questionTitle: 'Selecione o método de uso',
};

const QuizUsage = ({ onContinue }: MarisaAutoStepsProps) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
  } = useForm<UsageQuizForm>({
    resolver: yupResolver(
      yup
        .object()
        .shape({
          usageVehicle: yup.string().required(),
        })
        .required()
    ),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
  const [options, setOptions] = useState<Radio.Item[]>([]);
  const { setUsageQuizAnswer } = useMarisaAutoForm();

  useEffect(() => {
    getUsageListUseCase().then((result) =>
      setOptions(
        result.usageList.map((item) => ({
          label: item.description,
          value: item.code.toString(),
        }))
      )
    );
  }, []);

  const onSubmit = useCallback(
    ({ usageVehicle }: UsageQuizForm) => {
      setUsageQuizAnswer(Number(usageVehicle));
      onContinue();
    },
    [setUsageQuizAnswer, onContinue]
  );

  return (
    <KeyboardScreenContainer
      footer={
        <View
          className={`flex xl:hidden ${
            Platform.OS === 'web' ? 'py-4 px-6' : ''
          }`}
        >
          <Footer disabled={!isValid} onSubmit={handleSubmit(onSubmit)} />
        </View>
      }
    >
      <View className="flex-1 container mx-auto xl:flex-row xl:pt-12 xl:pb-24">
        <Banner type="marisa-auto" />

        <View className="mt-8 xl:mt-0 px-6 flex-1 xl:ml-24">
          <Text className="text-xl mb-4 text-gray-600">
            {QUESTION.question}
          </Text>

          <Text className="text-gray-400 text-sm mb-8">
            {QUESTION.description}
          </Text>

          <Text className="text-base text-gray-600 mb-2">
            {QUESTION.questionTitle}
          </Text>

          <RadioGroup name={'usageVehicle'} control={control} items={options} />

          <Footer
            disabled={!isValid}
            className="hidden"
            onSubmit={handleSubmit(onSubmit)}
          />
        </View>
      </View>
    </KeyboardScreenContainer>
  );
};

export default QuizUsage;
